import React, { useState } from 'react';
import { apiRequest } from '../utils/api';

const SetupChecklist = ({ customerId, checklist, onUpdate }) => {
  const [editingNotes, setEditingNotes] = useState({});
  const [saving, setSaving] = useState({});

  const handleToggleComplete = async (stepId, currentStatus) => {
    setSaving({ ...saving, [stepId]: true });
    try {
      const data = await apiRequest(`/admin/customers/${customerId}/checklist/${stepId}`, {
        method: 'PUT',
        body: JSON.stringify({
          completed: !currentStatus,
        }),
      });

      if (data && data.success) {
        if (onUpdate) {
          onUpdate(data.data);
        }
      }
    } catch (error) {
      console.error('Error updating checklist:', error);
      alert('حدث خطأ أثناء تحديث القائمة');
    } finally {
      setSaving({ ...saving, [stepId]: false });
    }
  };

  const handleSaveNotes = async (stepId) => {
    setSaving({ ...saving, [stepId]: true });
    try {
      const data = await apiRequest(`/admin/customers/${customerId}/checklist/${stepId}`, {
        method: 'PUT',
        body: JSON.stringify({
          notes: editingNotes[stepId] || '',
        }),
      });

      if (data && data.success) {
        setEditingNotes({ ...editingNotes, [stepId]: undefined });
        if (onUpdate) {
          onUpdate(data.data);
        }
      }
    } catch (error) {
      console.error('Error updating notes:', error);
      alert('حدث خطأ أثناء حفظ الملاحظات');
    } finally {
      setSaving({ ...saving, [stepId]: false });
    }
  };

  const completedCount = checklist?.filter(item => item.completed).length || 0;
  const totalCount = checklist?.length || 0;
  const progressPercentage = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

  if (!checklist || checklist.length === 0) {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">قائمة الإعداد الأولي</h3>
        </div>
        <div className="card-body">
          <p>لا توجد خطوات في القائمة</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">قائمة الإعداد الأولي</h3>
        <div style={{ marginTop: '0.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
            <span style={{ fontSize: '0.9rem', color: '#666' }}>
              التقدم: {completedCount} / {totalCount}
            </span>
            <span style={{ fontSize: '0.9rem', fontWeight: 'bold', color: '#667eea' }}>
              {progressPercentage}%
            </span>
          </div>
          <div style={{ width: '100%', height: '8px', backgroundColor: '#f0f0f0', borderRadius: '4px', overflow: 'hidden' }}>
            <div
              style={{
                width: `${progressPercentage}%`,
                height: '100%',
                backgroundColor: '#667eea',
                transition: 'width 0.3s ease',
              }}
            />
          </div>
        </div>
      </div>
      <div className="card-body">
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {checklist.map((item, index) => (
            <div
              key={item.stepId}
              style={{
                padding: '1rem',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: item.completed ? '#f8f9fa' : '#ffffff',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                <div style={{ minWidth: '24px', paddingTop: '2px' }}>
                  <span style={{ fontSize: '0.9rem', color: '#666', fontWeight: 'bold' }}>
                    {index + 1}.
                  </span>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
                    <label
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        cursor: saving[item.stepId] ? 'not-allowed' : 'pointer',
                        flex: 1,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={item.completed || false}
                        onChange={() => handleToggleComplete(item.stepId, item.completed)}
                        disabled={saving[item.stepId]}
                        style={{
                          width: '18px',
                          height: '18px',
                          cursor: saving[item.stepId] ? 'not-allowed' : 'pointer',
                        }}
                      />
                      <span
                        style={{
                          textDecoration: item.completed ? 'line-through' : 'none',
                          color: item.completed ? '#666' : '#333',
                          fontSize: '1rem',
                          fontWeight: item.completed ? 'normal' : '500',
                        }}
                      >
                        {item.label}
                      </span>
                    </label>
                    {item.completedAt && (
                      <span style={{ fontSize: '0.85rem', color: '#666' }}>
                        {new Date(item.completedAt).toLocaleDateString('en-US')}
                      </span>
                    )}
                  </div>

                  {/* Notes section */}
                  <div style={{ marginTop: '0.5rem', paddingTop: '0.5rem', borderTop: '1px solid #f0f0f0' }}>
                    {editingNotes[item.stepId] !== undefined ? (
                      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
                        <textarea
                          value={editingNotes[item.stepId]}
                          onChange={(e) => setEditingNotes({ ...editingNotes, [item.stepId]: e.target.value })}
                          placeholder="أضف ملاحظات..."
                          style={{
                            flex: 1,
                            padding: '0.5rem',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '0.9rem',
                            minHeight: '60px',
                            fontFamily: 'inherit',
                          }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => handleSaveNotes(item.stepId)}
                            disabled={saving[item.stepId]}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            حفظ
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            onClick={() => setEditingNotes({ ...editingNotes, [item.stepId]: undefined })}
                            disabled={saving[item.stepId]}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            إلغاء
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '0.5rem' }}>
                        <div style={{ flex: 1 }}>
                          {item.notes ? (
                            <p style={{ margin: 0, fontSize: '0.9rem', color: '#666', whiteSpace: 'pre-wrap' }}>
                              {item.notes}
                            </p>
                          ) : (
                            <p style={{ margin: 0, fontSize: '0.85rem', color: '#999', fontStyle: 'italic' }}>
                              لا توجد ملاحظات
                            </p>
                          )}
                        </div>
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          onClick={() => setEditingNotes({ ...editingNotes, [item.stepId]: item.notes || '' })}
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          {item.notes ? 'تعديل' : 'إضافة ملاحظات'}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SetupChecklist;

